import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "aria-labelledby"]
const _hoisted_2 = { class: "o-brokerPreview__bottom" }
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "o-brokerPreview__logo",
  src: "/assets/images/logo.svg",
  alt: "danbolig logo",
  width: "152",
  height: "35",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_5 = ["textContent"]
const _hoisted_6 = {
  key: 1,
  class: "a-lead o-brokerPreview__name",
  textContent: 'Ukendt navn'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: `${$props.broker.url}`,
    class: "o-brokerPreview",
    "aria-labelledby": $data.uuid,
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onClick()))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", {
        id: $data.uuid,
        class: "o-brokerPreview__address"
      }, [
        _hoisted_4,
        ($props.broker.name)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "a-lead o-brokerPreview__name",
              textContent: _toDisplayString($props.broker.name.replace('danbolig ', ''))
            }, null, 8 /* PROPS */, _hoisted_5))
          : (_openBlock(), _createElementBlock("span", _hoisted_6))
      ], 8 /* PROPS */, _hoisted_3)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}